import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "card" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title mb-2" }, "Manage Templates"),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("small", null, "During Beta, as a thank you, the Convorally team will make all of your document templates interactive. We eill generate your document link within 24 to 48 hours and notify you via email.")
  ])
], -1)
const _hoisted_2 = { class: "card p-0" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-shadowed mb-0" }
const _hoisted_5 = /*#__PURE__*/_createVNode("thead", { class: "table-primary" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Upload Template"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Uploaded By"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Uploaded Date"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Current Status"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Edoc")
  ])
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-external-link-alt mx-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "user-img-wrap" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "badge badge-alert" }, "Done", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "badge badge-warning" }, "Pending", -1)
const _hoisted_15 = {
  key: 0,
  class: "url-wrap"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fa fa-clipboard text-primary" }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "square-icon",
  title: "Edit Clipboard"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fas fa-edit text-success" }, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "url-wrap"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "fas fa-save text-info" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode()
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times text-danger" }, null, -1)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { colspan: "5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("table", _hoisted_4, [
          _hoisted_5,
          (_ctx.pdfDigitizeList && _ctx.pdfDigitizeList.length)
            ? (_openBlock(), _createBlock("tbody", _hoisted_6, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pdfDigitizeList, (document, documentIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: documentIndex }, [
                    _createVNode("td", null, [
                      _createVNode("p", null, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.openPdf(document.file_path))
                        }, [
                          _createTextVNode(_toDisplayString(document.name) + " ", 1),
                          _hoisted_7
                        ], 8, ["onClick"]),
                        _hoisted_8,
                        _createVNode("small", null, [
                          _createVNode("i", null, "(" + _toDisplayString(document.convertedFileSize) + ")", 1)
                        ])
                      ])
                    ]),
                    _createVNode("td", null, [
                      (document.client && document.client.email)
                        ? (_openBlock(), _createBlock("p", _hoisted_9, [
                            _createVNode("span", _hoisted_10, [
                              (document.client.image)
                                ? (_openBlock(), _createBlock("img", {
                                    key: 0,
                                    src: document.client.image,
                                    alt: ""
                                  }, null, 8, ["src"]))
                                : (_openBlock(), _createBlock("img", {
                                    key: 1,
                                    src: _ctx.state.data.imageBaseUrl ? `${_ctx.state.data.imageBaseUrl}img/avatar-1.jpg` : 'img/avatar-1.jpg' ,
                                    alt: ""
                                  }, null, 8, ["src"]))
                            ]),
                            _createTextVNode(" " + _toDisplayString(document.client.full_name), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("p", null, _toDisplayString(document.created_at), 1)
                    ]),
                    _createVNode("td", null, [
                      (document.status && document.status.code === 'ready')
                        ? (_openBlock(), _createBlock("p", _hoisted_11, [
                            _hoisted_12
                          ]))
                        : (_openBlock(), _createBlock("p", _hoisted_13, [
                            _hoisted_14
                          ]))
                    ]),
                    _createVNode("td", null, [
                      (document.edoc_id && !document.enableSave)
                        ? (_openBlock(), _createBlock("div", _hoisted_15, [
                            _createVNode("input", {
                              title: "Click to Edit",
                              readonly: "",
                              type: "text",
                              class: "form-control edit-on-click",
                              value: document.edoc_id,
                              id: `myInput${documentIndex}`,
                              onClick: ($event: any) => (_ctx.showEditable(document))
                            }, null, 8, ["value", "id", "onClick"]),
                            (!document.enableSave)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 0,
                                  class: "square-icon",
                                  title: "Copy to Clipboard",
                                  onClick: ($event: any) => (_ctx.copyDocumentSharableLink(`myInput${documentIndex}`))
                                }, [
                                  _hoisted_16
                                ], 8, ["onClick"]))
                              : (_openBlock(), _createBlock("span", _hoisted_17, [
                                  _hoisted_18
                                ]))
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_19, [
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control edit-mode",
                              "onUpdate:modelValue": ($event: any) => (document.tempShareableLink = $event),
                              onKeyup: _withKeys(($event: any) => (_ctx.resetSharableLink(document)), ["esc"])
                            }, null, 40, ["onUpdate:modelValue", "onKeyup"]), [
                              [_vModelText, document.tempShareableLink]
                            ]),
                            (document.showSaveButton)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 0,
                                  class: "square-icon",
                                  title: "Copy to Clipboard",
                                  onClick: ($event: any) => (_ctx.uploadSharableLink(document))
                                }, [
                                  _hoisted_20
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            _hoisted_21,
                            (document.showSaveButton)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 1,
                                  class: "square-icon",
                                  title: "Edit",
                                  onClick: ($event: any) => (_ctx.resetSharableLink(document))
                                }, [
                                  _hoisted_22
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("tfoot", _hoisted_23, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_24, [
                    _createVNode(_component_EmptyData, {
                      title: _ctx.state.data.title,
                      heading: _ctx.state.data.heading
                    }, null, 8, ["title", "heading"])
                  ])
                ])
              ]))
        ])
      ])
    ])
  ]))
}